<template>
  <div class="index-page container">
    <n-card :loading="$var('load')" style="max-width: 800px;">
      <n-form @submit="submit">
        <n-items>
          <n-input v-bind="$form.input('username')" title="Логин" />
          <n-input v-bind="$form.input('fullName')" title="Имя" />
          <n-input v-bind="$form.input('password')" title="Пароль" />
          <n-button color="primary" wide type="submit">Сохранить</n-button>
        </n-items>
      </n-form>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
  }),
  mounted() {
    this.$form.init({
      username: '',
      fullName: '',
      password: '',
    })
  },
  methods: {
    submit() {
      this.$var('load', true)
  
      $api.app.users.create(this.$form.get()).then((result) => {
        this.$router.push({ name: 'users.edit', params: { id: result.data.content.id, }, })
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
  }
</style>
